export const GET_CART_ITEMS_REQUEST = 'GET_CART_ITEMS_REQUEST';
export const GET_CART_ITEMS_SUCCESS = "GET_CART_ITEMS_SUCCESS"
export const GET_CART_ITEMS_FAILURE = "GET_CART_ITEMS_FAILURE"

export const POST_CART_ITEMS_REQUEST = 'POST_CART_ITEMS_REQUEST'
export const POST_CART_ITEMS_SUCCESS = 'POST_CART_ITEMS_SUCCESS'
export const POST_CART_ITEMS_FAILURE = 'POST_CART_ITEMS_FAILURE'


export const REMOVE_CART_ITEM_REQUEST = 'REMOVE_CART_ITEM_REQUEST'
export const REMOVE_CART_ITEM_SUCCESS = 'REMOVE_CART_ITEM_SUCCESS'
export const REMOVE_CART_ITEM_FAILURE = 'REMOVE_CART_ITEM_FAILURE'